import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum MethodPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const MethodResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.METHOD).default(ResourceType.METHOD),
    description: z.string(),
});
export const MethodMutationResourceSchema = getMutationSchema(MethodResourceSchema);

export type MethodResource = z.infer<typeof MethodResourceSchema>;

export const defaultMethodResource: MethodResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.METHOD,
    description: '',
};

export function useMethodActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/method',
            ResourceType.METHOD,
            MethodResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter('project/method', ResourceType.METHOD, MethodResourceSchema),
    };
}
